
<div class="text-center mt-5" *ngIf="isLoading" class="loader-container"> 
    <span class="customer-page-loader"></span>
  </div>